import { render, staticRenderFns } from "./BannedVisitors.vue?vue&type=template&id=65e0c188"
import script from "./BannedVisitors.vue?vue&type=script&lang=js"
export * from "./BannedVisitors.vue?vue&type=script&lang=js"
import style0 from "./BannedVisitors.vue?vue&type=style&index=0&id=65e0c188&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports